import { RootState } from 'editor/src/store/index';

import getPdfSplits from './getPdfSplits';

const isPdfSplitRunning = (state: RootState) =>
  getPdfSplits(state).some((split) => split.status === 'splitting' || split.status === 'saving');

export default isPdfSplitRunning;
